import { METHOD } from 'services/method'

export const API_BEST_DEALS = {
    DETAIL: {
        api: '/v1/dashboard-admin/main-page/home-page/best-deal',
        method: METHOD.GET,
    },
    PRODUCT_LIST: {
        api: '/v1/dashboard-admin/main-page/home-page/best-deal/product',
        method: METHOD.GET,
    },
    UPDATE: {
        api: '/v1/dashboard-admin/main-page/home-page/best-deal',
        method: METHOD.PUT,
    },
}
